import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Select, { SingleValue } from "react-select";

import { changeSelectOption } from '../../store/scheduleStore';

import { RootState } from "../../store/store";
import { customStyles } from './style';
import './CustomSelect.scss';

interface Option {
  category: number;
  value: string;
  label: string;
  index: number;
  selected: boolean;
}

interface CustomScheduleSelectProps {
  customClass?: string;
}

function CustomScheduleSelect({ customClass = '' }: CustomScheduleSelectProps) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectOptions } = useSelector((state: RootState) => state.schedule);
  
  const [selectedOption, setSelectedOption] = useState<Option | null>(selectOptions.filter((option: Option) => option.selected) || selectOptions[0] || null);


  useEffect(() => {
    if(selectOptions.length === 0) {
      return;
    }

    setSelectedOption(selectOptions.filter((option: Option) => option.selected) || selectOptions[0]);

    if(selectOptions.filter((option: Option) => option.selected)) {

      const selected = selectOptions.filter((option: Option) => option.selected)[0];
      if (selected) {
        dispatch(changeSelectOption({ value: selectOptions.filter((option: Option) => option.selected)[0].value, index: selectOptions.filter((option: Option) => option.selected)[0].index }));
      }
    }
  }, [selectOptions, dispatch]);

  function changeOptions(value: SingleValue<Option>) {
    if (value) {
      const index = selectOptions.findIndex((option: Option) => {
        return option.value === value.value;
      });
      const optionValue = value.value;
      setSelectedOption(selectOptions[index] || null);
      dispatch(changeSelectOption({ value: optionValue, index: index }));
    } else {
      setSelectedOption(null);
    }
  }

  return (
    <div className={`custom-select-container ${customClass}`}>
      <Select
        options={selectOptions}
        styles={customStyles}
        value={selectedOption}
        onChange={(value) => changeOptions(value)}
        placeholder={t('filter')}
        isSearchable={false}
        aria-label={t('filter-label')}
      />
    </div>
  );
}

export default CustomScheduleSelect;